import { ReactNode, useMemo } from 'react';
import { LiquidEngine } from '../../utils/liquidEngine';
import { useAuth } from '../AuthContext';
import { createChatProvider } from './chatProvider';
import { createDashboardProvider } from './dashboardProvider';
import {
    createModalProvider,
    ModalRender,
} from './modalProvider';
import { createPulseProvider } from './pulseProvider';
import { AdminContext } from './context';

// Preserve the existing import path while sharing one context across refreshes.
export { useAdminContext } from './context';
export type { AdminState } from './context';

const liquidEngine = new LiquidEngine();

function WorkspaceScopedAdminProviders(props: {
    children: ReactNode;
    workspaceId?: string;
}) {
    // 创建各个模块的 Provider
    const chat = createChatProvider();
    // const space = createSpaceProvider();
    const pulse = createPulseProvider(props.workspaceId);
    const dashboard = createDashboardProvider(props.workspaceId);
    const modal = createModalProvider();

    // 使用 useMemo 缓存 context 值
    const contextValue = useMemo(() => ({
        chat,
        // space,
        pulse,
        dashboard,
        modal,
        liquidEngine
    }), [chat, pulse, dashboard, modal]);

    return (
        <AdminContext.Provider value={contextValue}>
            {props.children}
            <ModalRender modalState={modal} />
        </AdminContext.Provider>
    );
}

// 完整的 AdminProvider 包装器
export const AdminProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const { currentWorkspace } = useAuth();
    const workspaceScopeKey = currentWorkspace?.id || 'no-workspace';

    return (
        <WorkspaceScopedAdminProviders
            key={workspaceScopeKey}
            workspaceId={currentWorkspace?.id}
        >
            {children}
        </WorkspaceScopedAdminProviders>
    );
};
